<style lang="scss">




@media screen and (min-width: 55rem) {
  .schoolcards {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .schoolcards-container {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      .cards-item {
        height: 110%;
        width: 25%;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        border-radius: 1rem;
        box-shadow: 0px 2px 4px rgb(0 0 0 / 10%);
        .cards-item-conatiner {
          margin-top: 2rem;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          .cards-item-logo {
            width: 4rem;
            height: 4rem;
            background-image: url("/media/yintai/school-4.png");
            background-size: 100% 100%;
          }
          .cards-item-title {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }
          .cards-item-qr-container {
            width: 13rem;
            height: 8rem;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            .cards-item-left {
              display: flex;
              flex-direction: column;
              align-content: center;
              .cards-item-left-top {
                width: 6rem;
                height: 6rem;
                background-image: url("/media/yintai/school-card1-qr1.png");
                background-size: 100% 100%;
              }
              .cards-item-left-bottom {
                text-align: center;
              }
            }

            .cards-item-right {
              display: flex;
              flex-direction: column;
              align-content: center;
              .cards-item-right-top {
                width: 6rem;
                height: 6rem;
                background-size: 100% 100%;
                background-image: url("/media/yintai/school-card1-qr2.png");
              }
              .cards-item-right-bottom {
                text-align: center;
              }
            }
          }
          .cards-item-span {
            width: 90%;
            text-align: left;
            font-size: 0.8rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
            line-height: 1.4rem;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .schoolcards {
    margin-top: 5rem;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .schoolcards-container {
      width: 65%;
      max-width: 1080px;
      .cards-item {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 1rem;
        box-shadow: 0px 2px 4px rgb(0 0 0 / 10%);
        margin-top: 2rem;
        .cards-item-conatiner {
          width: 60%;
          height: 80%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          padding-bottom: 2rem;
          .cards-item-logo {
            margin-top: 2rem;
            width: 4rem;
            height: 4rem;
            background-image: url("/media/yintai/school-4.png");
            background-size: 100% 100%;
          }
          .cards-item-title {
            font-size: 1rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 500;
            color: #333333;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }
          .cards-item-qr-container {
            width: 13rem;
            height: 8rem;
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            .cards-item-left {
              display: flex;
              flex-direction: column;
              align-content: center;
              .cards-item-left-top {
                width: 6rem;
                height: 6rem;
                background-image: url("/media/yintai/school-card1-qr1.png");
                background-size: 100% 100%;
              }
              .cards-item-left-bottom {
                text-align: center;
              }
            }

            .cards-item-right {
              display: flex;
              flex-direction: column;
              align-content: center;
              .cards-item-right-top {
                width: 6rem;
                height: 6rem;
                background-size: 100% 100%;
                background-image: url("/media/yintai/school-card1-qr2.png");
              }
              .cards-item-right-bottom {
                text-align: center;
              }
            }
          }
          .cards-item-span {
            width: 80%;
            text-align: start;
            font-size: 0.8rem;
            font-family:  'PingFang SC','Microsoft YaHei';
            font-weight: 400;
            color: #7f7f7f;
            line-height: 1.4rem;
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: "school-card",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
